import { useEffect, useState } from "react";
import QrScannerComponent from "../../../shared/QrScannerComponent";
import Api from "../../../../services/ApiService";
import { Spinner } from "react-bootstrap";

const ScanQrMask = ({data, setData, setStep}) => {

    const API = new Api();
    const [isScanned, setIsScaned] = useState(false);
    const [qrCode, setQrCode] = useState("");
    const [qrError, setQrError] = useState("");

    useEffect(() => {
        if (isScanned === true) {
            API.anlagen_get_by_qr(qrCode)
                .then(res => {
                    if (res.data.length > 0) {
                        var anlagen = res.data;
                        anlagen.forEach(a => {
                            a.register = true;
                        });
                        setData(prev => ({...prev, 
                            qr_code: qrCode,
                            anlagen: anlagen
                        }));
                        setStep("register")
                    
                    } else {
                        setIsScaned(false);
                        setQrCode("");
                    }
                })
        }
    }, [isScanned])

    return (
        <>
            {isScanned ?
                <div className="text-center">
                    <Spinner animation="grow" className="text-energo mx-2" />
                    <Spinner animation="grow" className="text-energo mx-2" />
                    <Spinner animation="grow" className="text-energo mx-2" />
                    <p className="text-center">QR Code wird überprüft</p>
                </div>
                :
                <QrScannerComponent setQrCode={setQrCode} setQrError={setQrError} setIsScanned={setIsScaned} />
            }
        </>
    )
}
export default ScanQrMask;